import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { Button } from 'antd';

interface SupportSuccessProps {
    onSubmitAnother: () => void;
}

export const SupportSuccess: React.FC<SupportSuccessProps> = ({
    onSubmitAnother,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-12 px-6">
            <div className="flex flex-col items-center text-center max-w-md">
                <CheckCircleIcon className="w-16 h-16 text-green-500 mb-6" />

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                    {t('forms.support.thankYou')}
                </h2>

                <p className="text-gray-600 text-M-16 mb-4">
                    {t('forms.support.ticketCreated')}
                </p>

                <p className="text-gray-500 text-M-16 mb-8">
                    {t('forms.support.responseTime')}
                </p>

                <Button
                    size="large"
                    onClick={onSubmitAnother}
                    className="btn-secondary"
                >
                    {t('forms.support.submitAnother')}
                </Button>
            </div>
        </div>
    );
};
